import React, { Fragment } from 'react';
import { useNavigate } from 'react-router';
import {
    Row, Card, Col, Badge
} from 'reactstrap';
import { H4, LI, P, Image, UL, Btn } from '../../../AbstractElements';
import errorImg from '../../../assets/images/search-not-found.png';
import { useSelector, useDispatch } from 'react-redux';
import { handleDelete } from 'Component/DashboardQeza/Common/DeleteUtils';
import { deleteVoucher } from 'Services/Features/Voucher/Utils/voucherUtils';
import { setFormData } from 'Services/Features/Voucher/voucherSlice';
import Moment from 'react-moment';

const VoucherContent = ({ setRefetch }) => {
    const vouchers = useSelector((state) => state.voucher.vouchers);
    
    // const currentCategory = useSelector((state) => state.category.currentCategory);
    const dispatch = useDispatch();
    const layoutColumns = 3;
    const history = useNavigate();


    const handleEdit = (item) => {
        console.log(item, 'handleEditItem');
        // Simpan data photos dan banner ke state terpisah
        dispatch(setFormData({ bannerLink: item.banner }));

        // Buat objek baru tanpa banner
        const { banner, ...updatedItem } = item;
        dispatch(setFormData({
            ...updatedItem,
        }));

        history(`${process.env.PUBLIC_URL}/treatment-voucher/edit/${item.id}`);
    };

    const getBadgeColor = (quota) => {
        if (quota < 5) return 'danger';
        if (quota <= 10) return 'primary';
        return 'success';
    };


    return (
        <Fragment>
            <div className="product-wrapper-grid">
                <Row className="gridRow">
                    {vouchers && vouchers.map((item) => {
                        return (
                            <div id="gridId" className={`${layoutColumns === 3 ? 'col-xl-4 col-lg-6 col-sm-6 xl-4' : 'col-xl-' + layoutColumns}`} key={item.id}>
                                <Card >
                                    <div className="product-box">
                                        <div className="product-img" style={{ height: 'auto', width: 'auto', overflow: 'hidden' }}>
                                            <Image attrImage={{ className: 'img-fluid w-100', src: item.banner ? item.banner : errorImg, alt: `${item.name}`, style: { height: '100%', objectFit: 'cover' } }} />
                                            <div className="product-hover">
                                                <UL attrUL={{ className: 'simple-list' }}>
                                                    <LI title="Delete" onClick={() => handleDelete(dispatch, item.id, setRefetch, deleteVoucher)}><Btn attrBtn={{ color: 'transprant', type: 'button', datatoggle: 'modal', datatarget: '#exampleModalCenter' }}><i className="icon-trash"></i></Btn> </LI>
                                                </UL>
                                                <UL attrUL={{  }} style={{  marginBottom: '20px' }}>
                                                    <LI title="Edit" onClick= {() => handleEdit(item)}><Btn attrBtn={{ color: 'transprant', type: 'button' }}><i className="icon-pencil-alt"></i></Btn></LI>
                                                </UL>
                                            </div>
                                        </div>
                                        <div className="product-details">
                                            <H4>
                                                <span title={item.name} style={{ cursor: 'default', color: 'inherit', textTransform: 'none'  }}>
                                                    {item.name && item.name.length > 23 ? `${item.name.substring(0, 23)}...` : item.name}
                                                </span>
                                            </H4>
                                            <Row>
                                                <Col md={12} className="order-md-1 order-2">
                                                    <div className="d-flex">
                                                        <div style={{ minWidth: '80px', fontWeight: 'bold' }}>
                                                            <i className="icon-ticket text-success"></i> Kode
                                                        </div>
                                                        <div><b>: </b>{item.code}</div>
                                                    </div>
                                                </Col>
                                                <Col md={8} className="order-md-2 order-3">
                                                    <div className="d-flex">
                                                        <div style={{ minWidth: '80px', fontWeight: 'bold' }}>
                                                            <i className="icon-cut text-secondary"></i> Diskon
                                                        </div>
                                                        <div><b>: </b>{item.type === 'percentage' ? `${item.discount}%` : `Rp ${item.discount}`}</div>
                                                    </div>
                                                </Col>
                                                <Col md={4} className="order-md-3 order-first">
                                                    {/* Kuota di atas di mobile, posisi ke-3 di desktop */}
                                                    <div className="d-flex">
                                                        <div>
                                                            <Badge color={getBadgeColor(item.quota)} className="text-white" style={{ fontSize: '12px' }}>
                                                                <i className="icon-pie-chart text-white me-1"></i>Kuota : {item.quota}
                                                            </Badge>
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col md={8} className="order-md-4 order-4">
                                                    <div className="d-flex">
                                                        <div style={{ minWidth: '80px', fontWeight: 'bold' }}>
                                                            <i className="icon-alert text-danger"></i> Expired
                                                        </div>
                                                        <div>
                                                            <b>: </b>
                                                            <Moment format="DD MMM YYYY, HH:mm:ss">
                                                                {item.expired_at}
                                                            </Moment>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        );
                    })}
                </Row>
            </div>
        </Fragment>
    );
};
export default VoucherContent;